"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var TicketNoOrderFilter = function TicketNoOrderFilter(_ref) {
  var value = _ref.value,
    name = _ref.name,
    onChange = _ref.onChange;
  var isChecked = Array.isArray(value) && value.includes('none');
  return /*#__PURE__*/_react["default"].createElement(StyledFilter, null, /*#__PURE__*/_react["default"].createElement("li", {
    key: "no_order"
  }, /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    checked: isChecked,
    onChange: onChange,
    name: name,
    value: "none"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "\u0411\u0435\u0437 \u0437\u0430\u043A\u0430\u0437\u0430"))));
};
var StyledFilter = _styledComponents["default"].ul.withConfig({
  displayName: "TicketNoOrderFilter__StyledFilter",
  componentId: "sc-i15uaj-0"
})([""]);
var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "TicketNoOrderFilter__StyledCheckbox",
  componentId: "sc-i15uaj-1"
})(["span{margin-left:4px;}"]);
var _default = exports["default"] = TicketNoOrderFilter;